"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const redux_1 = require("redux");
const redux_saga_1 = __importDefault(require("redux-saga"));
const effects_1 = require("redux-saga/effects");
const saga_1 = __importDefault(require("./app/saga"));
const slice_1 = require("./app/slice");
const slice_2 = require("./articleCreating/slice");
const slice_3 = require("./articleLike/slice");
const reducer_1 = __importDefault(require("./listUserBlock/reducer"));
const reducer_2 = __importDefault(require("./listUserFollow/reducer"));
const reducer_3 = __importDefault(require("./listUserMute/reducer"));
const saga_2 = __importDefault(require("./login/saga"));
const slice_4 = require("./login/slice");
const reducer_4 = __importDefault(require("./loginFirebase/reducer"));
const saga_3 = __importDefault(require("./loginFirebase/saga"));
function* rootSaga() {
    yield (0, effects_1.all)([(0, saga_1.default)(), (0, saga_2.default)(), (0, saga_3.default)()]);
    // code after all-effect
}
const allReducers = (0, redux_1.combineReducers)({
    appReducer: slice_1.appReducer,
    loginReducer: slice_4.loginReducer,
    loginFirebaseReducer: reducer_4.default,
    articleCreatingReducer: slice_2.articleCreatingReducer,
    articleLikeReducer: slice_3.articleLikeReducer,
    listFollowReducer: reducer_2.default,
    listBlockReducer: reducer_1.default,
    listMuteReducer: reducer_3.default,
});
const rootReducers = (state, action) => {
    return allReducers(state, action);
};
const sagaMiddleware = (0, redux_saga_1.default)();
const createAppStore = () => {
    const Store = (0, redux_1.legacy_createStore)(rootReducers, (0, toolkit_1.applyMiddleware)(sagaMiddleware));
    sagaMiddleware.run(rootSaga);
    return Store;
};
exports.store = createAppStore();
